module.exports = __webpack_public_path__ + "8e0b3d354ca4fa9d7efd712ece96461a.jpg";